import { render, staticRenderFns } from "./SurveyToDoDetails.vue?vue&type=template&id=438d394d"
import script from "./SurveyToDoDetails.vue?vue&type=script&lang=js"
export * from "./SurveyToDoDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports